import { useDispatch, useSelector } from "react-redux";
import SysGlobalKeyValueservice from "../service/MasterServices/SysGlobalKeyValueService";
import { ActionType } from "../store/ActionType";
import { useState } from "react";

const useGlobal = () => {
    const { data } = useSelector(state => state.global || []);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();

    const getGlobal = async () => {
        // Check if the list is an array and if it's empty
        if (data.length === 0 && !isLoading) {
            const res = await SysGlobalKeyValueservice.getGlobal();

            if (res && res.isSuccess) {


                dispatch({
                    type: ActionType.ADD_LIST,
                    payload: res.resultObject, // Send the fetched data
                });

                setIsLoading(true);
            }
        }
    };


    /// this function it just check the global message without create
    const g = (key) => {
        const item = data.find(r => r.key === key); // Use find to get the item by key
        /*if (item == undefined) {
            data.push({ key: key });
            SysGlobalKeyValueservice.registerKey({ Key: key });
        }*/

        return item ? item.value : key; // Return the value or the key if not found
    };

    // this function it create request if item not exists
    const t = (key) => {
        const item = data.find(r => r.key === key); // Use find to get the item by key
        if (item === undefined) {
            data.push({ key: key });
            SysGlobalKeyValueservice.registerKey({ Key: key });
        }

        return item ? item.value : key; // Return the value or the key if not found
    };

    return {
        getGlobal,
        g,
        t,
        isLoading
    };
}

export default useGlobal;
